import React from "react";
import { Link } from "react-router-dom";
import {
  Brain,
  HeartPulse,
  SmilePlus,
  Dna,
  Video,
  Globe,
  Biohazard,
  Radiation,
  Star,
  User,
  BookOpen,
  Stethoscope,
  PackageSearch,
} from "lucide-react";
import { banner_style } from "../Styles/styles";

const data = {
  event: {
    title: "About Us",
    date: "Mar 22-23 | 2027",
    organizer: "Helix Conferences",
    description: [
      <>
        At Helix Conferences, we are committed to fostering dialogue,
        discovery, and collaboration through world-class pharmaceutical
        conferences and summits. As a leading organizer of the Global
        Pharmaceutical Conclave and the World Pharmacology Summit, our mission
        is to connect stakeholders across the pharmaceutical ecosystem to
        accelerate global health solutions.
      </>,
      <>
        From emerging biotech to big pharma, from regulatory trends to Research
        ethics—we curate thought-provoking content and create impactful spaces
        where innovation thrives. Explore our{" "}
        <Link
          to="https://pharmatech.helixconferences.com/pharmaceutical-conference-tracks/"
          target="blank"
          rel="noopener noreferrer"
          className="text-accent font-bold"
        >
          Pharmaceutical Conferences
        </Link>{" "}
        to engage with dynamic sessions across the full pharma value chain.
      </>,
    ],
  },

  whyAttend: [
    "Attending our Pharma Conferences offers unmatched opportunities for growth and global exposure. Join industry pioneers and innovators as they present groundbreaking insights.",
    "Connect with world-class researchers and companies showcasing disruptive technology and science.",
    "Engage with regulators, policymakers, and ethics leaders shaping the future of pharma globally.",
    "Gain actionable knowledge on regulatory compliance, drug discovery, and therapeutic innovation.",
    "Be part of a movement focused on shaping the next era of pharmaceutical development and access.",
  ],

  aboutHelix: [
    "Helix Conferences has earned international recognition for organizing premium pharma and healthcare events. We design our conferences with a focus on strategic insights, regulatory trends, and scientific breakthroughs to ensure attendees leave with real-world knowledge and partnerships.",
  ],

  whoShouldAttend: [
    "Pharma professionals and researchers",
    "Biotech and clinical R&D experts",
    "Regulatory affairs and compliance officers",
    "Academicians and industry consultants",
    "Students and early-career scientists in pharma",
  ],

  join: [
    "Join us at the 2026 PharmaTech Summit to experience the fusion of science, strategy, and solution-driven innovation. Be part of the conversations that are transforming drug discovery, safety, and delivery at scale.",
  ],

  themes: [
    {
      icon: Brain,
      title: "Pharmacology",
      description:
        "Exploring Drug Action: Foundations and Frontiers in Pharmacology",
    },
    {
      icon: HeartPulse,
      title: "Pharmaceutics",
      description: "Innovations in Drug Formulation and Delivery Systems",
    },
    {
      icon: SmilePlus,
      title: "Pharmacognosy",
      description:
        "Natural Products and Herbal Drug Discovery in Modern Medicine",
    },
    {
      icon: Dna,
      title: "Pharmacovigilance",
      description:
        "Ensuring Drug Safety: Global Perspectives in Pharmacovigilance",
    },
    {
      icon: Video,
      title: "Pharma Regulatory Affairs",
      description:
        "Navigating Compliance: Regulatory Affairs in a Global Market",
    },
    {
      icon: Globe,
      title: "Traditional Medicine",
      description:
        "Integrating Ancient Wisdom with Modern Therapeutics",
    },
    {
      icon: Biohazard,
      title: "Pharma Chemistry",
      description:
        "Chemical Foundations of Drug Design and Synthesis",
    },
    {
      icon: Radiation,
      title: "Pharma Analysis",
      description:
        "Analytical Techniques in Pharmaceutical Quality Control",
    },
  ],

  highlights: [
    {
      title: "Keynote Speakers",
      description: "Pharma leaders share expert insights",
    },
    {
      title: "Panel Discussions",
      description: "Debates on ethics and policy",
    },
    {
      title: "Live Demonstrations",
      description: "Tools, equipment, AI in action",
    },
    {
      title: "Innovation Labs",
      description: "Hands-on with emerging pharma tech",
    },
    {
      title: "Poster Presentations",
      description: "Research findings and clinical data",
    },
    {
      title: "Workshops",
      description: "Practical training in pharma research",
    },
    {
      title: "Partnership Zones",
      description: "Meet brands, forge strategic alliances",
    },
    {
      title: "Awards & Recognition",
      description: "Honor excellence in pharmaceutical innovation",
    },
  ],


  dates: {
    eventDate: "Mar 22-23 | 2027",
    venue: "Novotel Valencia, Spain",
    registrationDeadline: "1st Mar 2027",
  },
};


const AboutPublicHealth = () => {
  return (
    <div className="w-full  mx-auto justify-center items-center text-center">
      <div className={`${banner_style} w-full mx-auto about-banner`}>
        <h1 className="text-slate-100 text-3xl sm:text-5xl md:text-6xl font-bold px-4 z-10">
          {data.event.title}
        </h1>
      </div>

      <h1 className="text-4xl mt-2 font-bold text-one">
        A CONFERENCE ON PHARMATECH-2027
      </h1>
      <p className="text-center text-gray-600 text-3xl mb-6">
        <strong>
          Mar 22-23 | 2027
        </strong>
      </p>

      {data.event.description.map((desc, idx) => (
        <p
          key={idx}
          className="mb-6 text-lg leading-relaxed text-justify w-full min-w-5xl px:2 md:px-12 lg:px-24"
        >
          {desc}
        </p>
      ))}

      {/* Why Attend Section */}
      {/* <section className="mb-10 text-center w-full max-w-4xl">
        <h2 className="text-3xl font-bold text-one mb-4">Why Attend the 2025 Oral Medicine Conference?</h2>
        {data.whyAttend.map((para, idx) => (
          <p key={idx} className="mb-3 text-base text-gray-700 text-center w-full">
            {para}
          </p>
        ))}
      </section> */}

      {/* About Helix Section */}
      {/* <section className="mb-10 text-center w-full max-w-4xl">
        <h2 className="text-3xl font-bold text-one mb-4">Helix Conferences: Leading the Way in Event Organization</h2>
        {data.aboutHelix.map((para, idx) => (
          <p key={idx} className="mb-3 text-base text-gray-700 text-center w-full">
            {para}
          </p>
        ))}
      </section> */}

      {/* Who Should Attend Section */}
      {/* <section className="mb-10 text-center w-full max-w-4xl">
        <h2 className="text-3xl font-bold text-one mb-4">Who Can Attend?</h2>
        <ul className="list-disc list-inside text-base text-gray-700 text-center w-full">
          {data.whoShouldAttend.map((item, idx) => (
            <li key={idx} className="mb-2">{item}</li>
          ))}
        </ul>
      </section> */}

      {/* Join Section */}
      <section className="mb-10 text-center w-full min-w-4xl px-2 md:px-12 lg:px-24">
        <h2 className="text-3xl font-bold text-one mb-4 w-full">
          Join the Global Community at PHARMATECH Conference 2026
        </h2>
        {data.join.map((para, idx) => (
          <p
            key={idx}
            className="mb-6 text-lg leading-relaxed text-justify w-full min-w-5xl px:2 md:px-12 lg:px-24"
          >
            {para}
          </p>
        ))}
      </section>

      {/* Themes Section */}
      <section className="mb-16 text-center w-full px-12">
        <h2 className="text-4xl my-8 font-bold text-one">Who Can Attend...</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <User className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">
              PHARMATECH Professionals
            </h3>
          </div>
          <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <BookOpen className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">
              Academics & Researchers
            </h3>
          </div>
          <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <Stethoscope className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">
              Healthcare Administrators
            </h3>
          </div>
          <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <PackageSearch className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">
              Healthcare product and Service providers
            </h3>
          </div>
          {/* <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <GraduationCap className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">Students and trainees in dentistry and related fields</h3>
          </div> */}
        </div>
      </section>

      {/* Highlights Section */}
      <section className="mb-16 text-center w-full px-12">
        <h2 className="text-4xl font-bold text-one mb-8">Event Highlights</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full items-start">
          {data.highlights.map((highlight, idx) => (
            <div
              key={idx}
              className="bg-white rounded-xl p-4 text-md text-gray-800 text-left flex items-start shadow-sm "
            >
              <Star className="w-4 h-4 text-yellow-500 fill-yellow-500 mr-3 mt-1" />
              <div className="flex flex-wrap items-start">
                <h3 className="font-semibold whitespace-nowrap mr-1">
                  {highlight.title} –
                </h3>
                <p className="text-md text-gray-600 flex-1">
                  {highlight.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Dates Section */}
      {/* <section className="mb-16 text-center w-full md:px-12 px-4">
        <h2 className="text-4xl font-bold text-one mb-8">
          Important Dates
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 w-full text-sm">
          <div className="bg-white rounded-xl shadow p-4 flex flex-col items-center">
            <Calendar className="w-6 h-6 text-one mb-2" />
            <strong>Event Date</strong>
            <p>{data.dates.eventDate}</p>
          </div>
          <div className="bg-white rounded-xl shadow p-4 flex flex-col items-center">
            <Globe className="w-6 h-6 text-one mb-2" />
            <strong>Proposed Venue</strong>
            <p>{data.dates.venue}</p>
          </div>
          <div className="bg-white rounded-xl shadow p-4 flex flex-col items-center">
            <BadgeCheck className="w-6 h-6 text-one mb-2" />
            <strong>Registration Deadline</strong>
            <p>{data.dates.registrationDeadline}</p>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default AboutPublicHealth;

